import React from "react";
import {stockStorage} from "../config/global";

export const useStockStorage = () => {

    function setStockStorageToken(tokenValue: any) {
        //console.log('setStockStorageToken: ' + tokenValue);
        sessionStorage.setItem(stockStorage.stockToken, JSON.stringify(tokenValue));
    }
    function getStockStorageToken() : string {
        var k = sessionStorage.getItem(stockStorage.stockToken);
        if(k)
            return JSON.parse(k);
        else
            return '';
    }
    function removeStockStorageToken() {
        //console.log('removeStockStorageToken');
        sessionStorage.removeItem(stockStorage.stockToken);
    }

    function setSessionStock(value: string) {
        sessionStorage.setItem(stockStorage.sessionStock, value);
    }
    function removeSessionStock() {
        sessionStorage.removeItem(stockStorage.sessionStock);
    }
    function getSessionStock() : string | null {
        var k = sessionStorage.getItem(stockStorage.sessionStock);

        if(k)
            return k;
        else
            return null;
    }

    function setNewSessionStock() {
        sessionStorage.setItem(stockStorage.newSessionStock, JSON.stringify(true));
    }
    function getNewSessionStock() : string | null {
        var k = sessionStorage.getItem(stockStorage.newSessionStock);
        if(k)
            return JSON.parse(k);
        else
            return null;
    }
    function removeNewSessionStock() {
        sessionStorage.removeItem(stockStorage.newSessionStock);
    }
    const newSessionStock = JSON.parse(getNewSessionStock() || 'false') as boolean;

    function setSessionStockRegion(value: string) {
        sessionStorage.setItem(stockStorage.sessionStockRegion, value);
    }
    function removeSessionStockRegion() {
        sessionStorage.removeItem(stockStorage.sessionStockRegion);
    }
    function getSessionStockRegion() : string | null {
        var k = sessionStorage.getItem(stockStorage.sessionStockRegion);

        if(k)
            return k;
        else
            return null;
    }

    function setSessionStockProvince(value: string) {
        sessionStorage.setItem(stockStorage.sessionStockProvince, value);
    }
    function removeSessionStockProvince() {
        sessionStorage.removeItem(stockStorage.sessionStockProvince);
    }
    function getSessionStockProvince() : string | null {
        var k = sessionStorage.getItem(stockStorage.sessionStockProvince);

        if(k)
            return k;
        else
            return null;
    }

    function setSessionStockPromoter(value: string) {
        sessionStorage.setItem(stockStorage.sessionStockPromoter, value);
    }
    function removeSessionStockPromoter() {
        sessionStorage.removeItem(stockStorage.sessionStockPromoter);
    }
    function getSessionStockPromoter() : string | null {
        var k = sessionStorage.getItem(stockStorage.sessionStockPromoter);

        if(k)
            return k;
        else
            return null;
    }

    function removeSessionStockAll() {
        removeSessionStock();
        removeNewSessionStock();
        removeSessionStockRegion();
        removeSessionStockProvince();
        removeSessionStockPromoter();
    }


    return {

        setStockStorageToken,
        getStockStorageToken,
        removeStockStorageToken,

        setSessionStock,
        removeSessionStock,
        getSessionStock,

        setNewSessionStock,
        getNewSessionStock,
        removeNewSessionStock,
        removeSessionStockAll,
        newSessionStock,

        setSessionStockRegion, removeSessionStockRegion, getSessionStockRegion,
        setSessionStockProvince, removeSessionStockProvince, getSessionStockProvince,
        setSessionStockPromoter, removeSessionStockPromoter, getSessionStockPromoter
    }
};
